<template>
  <div v-show="syncUI.drawUrl" class="flex_c h100 w100 draw-url" style="position: fixed; z-index: 4000; top: 0; left: 0; right: 0; bottom: 0; ">
    <iframe v-if="syncUI.drawUrl" :src="syncUI.drawUrl" frameborder="0" style="position: fixed;z-index: 999;width: 100%;height: 100%;margin: 0;padding: 0;"></iframe>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState(['syncUI']),
  },
  watch: {
    'syncUI.drawUrl': {
      handler(o, v) {
        this.$forceUpdate()
      }
    }
  },
  // mounted() {
  //   console.log(this.syncUI, 'drawbox');
  // },
}
</script>
